import {panel} from '@xpertdox_js/xdstyle';

export default {
  container: {
    ...panel,
    margin: '8px',
  },
  heading: {
    fontWeight:'600',
    fontSize: '16px',
    color:'rgb(125,136,145)',
    margin: '0px 0px 5px 1px'
  }
}
